import useSWR, { SWRResponse } from "swr";
import useHttpClient from "../useHttpClient";
import { LoanEligibility } from "../../types";

interface UseLoanEligibilityParams {
  principal?: number | null;
  repaymentPercent?: number | null;
}

const useLoanEligibility = (
  params?: UseLoanEligibilityParams
): SWRResponse<LoanEligibility, Error> => {
  const httpClient = useHttpClient();
  const { principal, repaymentPercent } = params ?? {};

  const query =
    principal && repaymentPercent
      ? `?principal=${principal}&repaymentPercent=${repaymentPercent}`
      : "";

  const key = `loan-eligibility${query}`;

  return useSWR(
    key,
    (): Promise<LoanEligibility> =>
      httpClient
        .get(`/loans/eligibility${query}`)
        .then((res) => res.data.data),
    { revalidateOnFocus: true }
  );
};

export default useLoanEligibility;
